const { debounce } = window.BAO.Utils

class HorizontalNav extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this?.els?.current?.exists && !window.BAO.MediaBreakpoints.isMd) {
      const currentPosition = this.els.current.element.offsetLeft
      this.menu.scrollLeft = currentPosition - 40
    }
  }

  static get requiredElements () {
    return ['menu', 'wrapper']
  }

  setupListeners () {
    if (this.rightArrow) {
      this.listeners.add(
        this.rightArrow,
        'click',
        this.handleRightClick.bind(this),
      )
    }

    if (this.leftArrow) {
      this.listeners.add(
        this.leftArrow,
        'click',
        this.handleLeftClick.bind(this),
      )
    }

    this.listeners.add(
      this.menu,
      'scroll',
      debounce(this.handleScroll.bind(this), 100),
    )
    this.listeners.add(
      window,
      'resize',
      debounce(this.handleResize.bind(this), 100),
    )

    this.listeners.add(window, 'load', this.checkNavArrows.bind(this))

    // Any other events you'd like to re-check the nav arrows on.
    this.extraEvents.forEach(event => {
      this.listeners.add(
        document,
        event,
        debounce(this.checkNavArrows.bind(this), 200),
      )
    })
  }

  checkNavArrows () {
    if (this.nextRightPosition > 0 || this.nextLeftPosition < 0) {
      this.classList.add('hor-Active')
    } else {
      this.classList.remove('hor-Active')
    }

    // Add the left arrow if the menu is overflowing to the right
    if (this.nextRightPosition > 0) {
      this.wrapper.classList.add('hor-Nav_RightFade')
      this.rightArrow?.classList.add('hor-Nav_Arrow-show')
    } else {
      this.wrapper.classList.remove('hor-Nav_RightFade')
      this.rightArrow?.classList.remove('hor-Nav_Arrow-show')
    }

    // Add the right arrow if the menu is overflowing to the left
    if (this.nextLeftPosition < 0) {
      this.wrapper.classList.add('hor-Nav_LeftFade')
      this.leftArrow?.classList.add('hor-Nav_Arrow-show')
    } else {
      this.wrapper.classList.remove('hor-Nav_LeftFade')
      this.leftArrow?.classList.remove('hor-Nav_Arrow-show')
    }
  }

  handleResize () {
    setTimeout(this.checkNavArrows.bind(this), 100)
  }

  handleScroll () {
    setTimeout(this.checkNavArrows.bind(this), 100)
  }

  handleLeftClick (e) {
    e.preventDefault()

    this.menu.scrollBy({
      left: this.nextLeftPosition,
      top: 0,
      behavior: 'smooth',
    })
  }

  handleRightClick (e) {
    e.preventDefault()

    this.menu.scrollBy({
      left: this.nextRightPosition,
      top: 0,
      behavior: 'smooth',
    })
  }

  get nextRightPosition () {
    if (!this.els.links?.elements.length) return 0

    const numElems = this.els.links.elements.length

    let nextRightElem = this.els.links.elements[numElems - 1]

    // Get the link element with the smallest right boundary.
    this.els.links.elements.some(item => {
      const rect = item.getBoundingClientRect()

      if (rect.left > this.menuRight) {
        nextRightElem = item

        return true
      }

      return false
    })

    const newPosition =
      nextRightElem.getBoundingClientRect().right - this.menuRight

    return newPosition === 0 ? 0 : Math.floor(newPosition)
  }

  get nextLeftPosition () {
    if (!this.els.links?.elements.length) return 0

    let nextLeftElem = this.els.links.elements[0]

    // Get the link element with the smallest left boundary.
    this.els.links.elements.reverse().some(item => {
      const rect = item.getBoundingClientRect()

      const difference = rect.left - this.menuLeft

      if (rect.left < this.menuLeft && difference < -5) {
        nextLeftElem = item

        return true
      }

      return false
    })

    const newPosition =
      nextLeftElem.getBoundingClientRect().left - this.menuLeft

    return newPosition === 0 ? 0 : Math.ceil(newPosition)
  }

  get leftArrow () {
    return this.els.left?.element
  }

  get rightArrow () {
    return this.els.right?.element
  }

  get wrapper () {
    return this.els.wrapper?.element
  }

  get menu () {
    return this.els.menu.element
  }

  get menuWidth () {
    return this.menu.getBoundingClientRect().width
  }

  get menuRight () {
    return this.menu.getBoundingClientRect().right
  }

  get menuLeft () {
    return this.menu.getBoundingClientRect().left
  }

  get extraEvents () {
    if (!this.dataset.extraEvents) return []

    return this.dataset.extraEvents.split(',')
  }
}

if (!customElements.get('horizontal-nav')) {
  customElements.define('horizontal-nav', HorizontalNav)
}
